import { render, staticRenderFns } from "./ZakelijkeInformatie.vue?vue&type=template&id=5b34d95a&"
import script from "./ZakelijkeInformatie.vue?vue&type=script&lang=js&"
export * from "./ZakelijkeInformatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports